import { extend } from 'vee-validate';
import { required, email, min, max, min_value as minValue, max_value as maxValue } from 'vee-validate/dist/rules';

extend('email', {
	...email,
	message: 'No es un email válido'
});

extend('required', {
	...required,
	message: 'El campo es obligatorio'
});

extend('relationRequired', {
	message: () => 'El campo es obligatorio',
	validate: (value) => {
		if (value) {
			if (value.key !== '') return true;
		}

		return false;
	}
});

extend('min', {
	...min,
	message: (field, attrs) => `Demasiado corto (${attrs.length} min)`
});

extend('max', {
	...max,
	message: (field, attrs) => `Demasiado largo (${attrs.length} max)`
});

extend('min_value', {
	...minValue,
	message: (field, attrs) => `Demasiado corto (${attrs.min} min)`
});

extend('max_value', {
	...maxValue,
	message: (field, attrs) => `Demasiado largo (${attrs.max} max)`
});

extend('password', {
	params: ['target'],
	validate(value, { target }) {
		return value === target;
	},
	message: 'La contraseña especificada es distinta'
});

/// ///////////////////
// OFICIAL FIELDS
/// ///////////////////

extend('_userNick', {
	validate: (value) => {
		if (value.length >= 3 && value.length <= 20) return true;
		return false;
	},
	message: () => 'El usuario debe tener entre 3 y 20 caracteres'
});

extend('_userPassword', {
	validate: (value) => {
		if (value.length >= 3 && value.length <= 20) return true;
		return false;
	},
	message: () => 'La contraseá debe tener entre 3 y 20 caracteres'
});
